import { FC } from 'react'

import { useAuth } from '@/features/auth'
import { ActionsWidget } from '@/features/shipments/view/requiredActions/actionsWidgetNew'
import { useMappedCustomerRequiredActions } from '@/features/workbench'
import { useLocalisation } from '@/utils/localisation'

const WIDGET_ACTIONS_SIZE = 3

export type ActionsProps = {
  id: string
  entityType?: string
}

export const EntityActions: FC<ActionsProps> = ({ id, entityType = 'shipment' }) => {
  const { translate } = useLocalisation()
  const { customer } = useAuth()
  const customerId = customer?._id || ''
  const pageSize = 10

  const { data: entityRequiredActions } = useMappedCustomerRequiredActions({
    customerId,
    pageSize,
    entityType: entityType,
    entityId: id,
  })
  const formattedActions = entityRequiredActions.results.slice(0, WIDGET_ACTIONS_SIZE)

  return (
    <ActionsWidget
      key={entityRequiredActions.total}
      actions={formattedActions}
      totalActions={entityRequiredActions.total}
      viewMoreLink={`/required-actions?${entityType}Id=${id}`}
      widgetTitle={translate('details.overview.actions.title')}
      hideEntityId
    />
  )
}
